// const BASE_URL = 'https://www.ipigai.cn:19000/'         //服务器
const BASE_URL = 'https://backend.ipigai.cn/'         //服务器
export default {
    BASE_URL
}

